module.exports = __webpack_public_path__ + "static/media/bpb.c4a1849d.jpeg";